
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import toStringTagSupport from '../internals/to-string-tag-support.js';
import defineBuiltIn$1 from '../internals/define-built-in.js';
import objectToString from '../internals/object-to-string.js';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var defineBuiltIn = defineBuiltIn$1;
var toString = objectToString;

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
}
//# sourceMappingURL=es.object.to-string.js.map
